import { createLazyFileRoute } from "@tanstack/react-router";

import { TestSpecsEditPage } from "@/features/admin/routes/TestSpecsEdit";

export const Route = createLazyFileRoute("/_auth/admin/tests/$id/edit/")({
  component: () => {
    const params = Route.useParams();
    return <TestSpecsEditPage id={params.id} />;
  },
});
